import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FilterItem, FilterType, InputType, PagingOptions, TextAreaOptions, TextBoxOptions } from 'bnsights-control-library';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { ClipboardService } from 'ngx-clipboard';
import { PageInfoService } from '../../../_metronic/core/services/page-info.service';
import { EmailHeaderAndFooterTemplateService } from '../../shared/Services/EmailHeaderAndFooterTemplateService.Service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthService, UtilityService, BBSFTranslateService, EnvironmentService } from 'bnsights-utilities-library';

@Component({
  selector: 'lib-master-layouts',
  templateUrl: './master-layouts.component.html'
})
export class MasterLayoutsComponent implements OnInit {

/*  SubheaderTitle = this.utilityService.getResourceValue('MasterLayouts');*/
  

  //ShowToolbar = true; ShowbreadCrumb = false;
  ApiUrl = "/api/admin/EmailHeaderAndFooterTemplate/"
  searchTextBox: TextBoxOptions;
  filterForm = new FormGroup({});
  EmailHeaderAndFooterTemplateForm = new FormGroup({});
  showFilter: boolean = false;
  EmailHeaderAndFooterTemplatePagingResult: any[] = [];
  EmailHeaderAndFooterTemplatePaging: PagingOptions;
  TextInputFilter: FilterItem;
  IsFilterLoaded: boolean = false;
  ProductionMode: boolean;
  language:string=""

  @ViewChild('EmailHeaderAndFooterTemplatePagingViewElement', { static: false }) input: ElementRef;


  //delete  Model Controls
  EmailHeaderAndFooterTemplateId:number;
  IsOpenDeleteEmailHeaderAndFooterTemplateModal: boolean = false
  @ViewChild('CloseDeleteEmailHeaderAndFooterTemplateModal', { static: false }) CloseDeleteEmailHeaderAndFooterTemplateModal: ElementRef;

  // Decorator wires up blockUI instance
  @BlockUI() blockUI: NgBlockUI;
  ShowPageContent:boolean=false;
   //GenerateCode  Model Controls 
   GenerateCodeForm = new FormGroup({});
   IsOpenGenerateCodeModal: boolean;
   GenerateCodeTextArea: TextAreaOptions;
   ValueToCopy:string="";

  constructor(private authService:AuthService,private pageInfoService:PageInfoService, public utilityService:UtilityService,private bbsfTranslateService:BBSFTranslateService,private environmentService:EnvironmentService, private emailHeaderAndFooterTemplateService: EmailHeaderAndFooterTemplateService, private _clipboardService: ClipboardService, private modalService: NgbModal) {
  }


  async ngOnInit(): Promise<void> {
    this.ShowPageContent=true;
    PageInfoService.PageTitle=this.utilityService.getResourceValue("MasterLayouts")
    PageInfoService.PageBreadcrumbs=[
       {title: this.utilityService.getResourceValue("Home") , path: '/Admin/Home', isSeparator: false, isActive: false},
       {title: '', path: '', isSeparator: true, isActive: false}

    ];
    this.pageInfoService.calculateTitle();
    this.pageInfoService.calculateBreadcrumbs();
    this.bbsfTranslateService.onLangChange.subscribe((event)=>{
      this.language = event.lang;
      this.ngOnInit();
    })
    this.language = await this.utilityService.getCurrentLanguage();
    this.ProductionMode = this.environmentService.getProductionMode()
    this.LoadList();
  }

 


  LoadList() {

     // TextBox inti
     this.searchTextBox = new TextBoxOptions();
     this.searchTextBox.Name = "searchTextBox"
     this.searchTextBox.Type = InputType.Text
    this.searchTextBox.Placeholder = this.utilityService.getResourceValue("SearchByName")
     this.searchTextBox.HideLabel = true


     this.TextInputFilter = new FilterItem();
     this.TextInputFilter.FormControlName = "searchTextBox"
     this.TextInputFilter.ActionParameterName = "searchText"
     this.TextInputFilter.IsFormControl = true
     this.TextInputFilter.FilterType = FilterType.TextBox

     this.EmailHeaderAndFooterTemplatePaging = new PagingOptions();
     this.EmailHeaderAndFooterTemplatePaging.ActionPostURL = this.environmentService.getApiUrl() + this.ApiUrl + 'GetEmailHeaderAndFooterTemplateByFilter';
     this.EmailHeaderAndFooterTemplatePaging.OnKeyPressFiltersControlNames = ["searchTextBox"]
     this.EmailHeaderAndFooterTemplatePaging.Filters = [this.TextInputFilter]
     this.EmailHeaderAndFooterTemplatePaging.ValidationToken = this.authService.authorizationHeaderValue()
     this.IsFilterLoaded = true;
     
  }

  ReinitializeEmailHeaderAndFooterTemplatePaging() {
    let element = this.input as any;
    element.ReinitializePaging();
  }

  UpdateEmailHeaderAndFooterTemplatePaging() {
    let element = this.input as any;
    element.UpdatePaging();
  }

  setEmailHeaderAndFooterTemplateResult(result) {
    this.EmailHeaderAndFooterTemplatePagingResult = result
    this.ShowPageContent=true;
    this.utilityService.stopBlockUI()
  }

  resetFilters() {
    this.EmailHeaderAndFooterTemplateForm.controls["searchTextBox"].setValue(null);
    let element = this.input as any;
    element.ReinitializePaging();
  }


  showDeleteEmailHeaderAndFooterTemplateModal(template: any, deleteEmailHeaderAndFooterTemplateModal) {
    this.EmailHeaderAndFooterTemplateId = template.id
    this.utilityService.startBlockUI();
    this.modalService.open(deleteEmailHeaderAndFooterTemplateModal);
    this.utilityService.stopBlockUI();


  }

  deleteEmailHeaderAndFooterTemplate() {
  
    this.emailHeaderAndFooterTemplateService.DeleteHeaderAndFooterTemplate(this.EmailHeaderAndFooterTemplateId ).subscribe((result) => {
      this.EmailHeaderAndFooterTemplateId = 0;
      this.modalService.dismissAll();
      let element = this.input as any;
      element.ReinitializePaging();
    }, (error) => {
     })

  }


  copyInputMessage(){
    this._clipboardService.copy(this.ValueToCopy.toString());
  }
  
 
  showGenerateCodeModal(GenerateCodeModal) {
    this.emailHeaderAndFooterTemplateService.GenerateCode().subscribe((result) => {
      var Value = result as any
      this.GenerateCodeTextArea = new TextAreaOptions();
      this.GenerateCodeTextArea.Name = "GenerateCodeTextArea";
      this.GenerateCodeTextArea.Value = Value.val.toString();
      this.ValueToCopy=Value.val.toString();
      this.GenerateCodeTextArea.IsDisabled = true;
      this.GenerateCodeTextArea.HideLabel = true;
      this.GenerateCodeTextArea.Rows = 20;
      this.GenerateCodeTextArea.Cols = 20;
      this.GenerateCodeTextArea.MaxLength = 1000000;
      this.modalService.open(GenerateCodeModal);

    }, (error) => {
     })
  }

}
